/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { useCallback } from "react";
import { useTranslate } from "@adapptio/lib-components";
import { ISchemaConstBooleanModel } from "@adapptio/lib-blueprint";
import { useBlueprintModel } from "../../../ui/hooks/useBlueprintModel";
import { FieldButton } from "@adapptio/lib-editor-ui";

export interface IInspectorControlButtonGroup_ButtonProps {
	model: ISchemaConstBooleanModel;
}

export const InspectorControlButtonGroup_Button: React.FC<IInspectorControlButtonGroup_ButtonProps> = ({
	model: _model
}) => {
	const { model } = useBlueprintModel(_model, "constBoolean");
	const t = useTranslate();

	const handleClick = useCallback(() => {
		if (!model) {
			return;
		}

		model.schema.setValue(model, !model.value, true);
	}, [ model ]);

	return (
		<FieldButton
			onClick={handleClick}
			selected={model.value}
			tooltip={t("editor", model.schema.opts.label)}
			icon={model.schema.opts.icon}
		>
			{!model.schema.opts.icon ? t("editor", model.schema.opts.label) : null}
		</FieldButton>
	);
};
